$(document).ready(function() {
	if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.plugins.external.svbadge: ondocumentready"); // eslint-disable-line no-console
	const offset = 300;
	const duration = 300;

	let isDesktop = window.matchMedia("(min-width: 768px)").matches;

	$(window).scroll(function() {
		if (isDesktop) {
			if ($(this).scrollTop() > offset) { // eslint-disable-line no-invalid-this
				$(".back-to-top").fadeIn(duration);
				$(".back-to-top-center").fadeIn(duration);
				if ($("#sv-rbadge-box").length) {
					$("#sv-rbadge-box").fadeIn(duration);
				}
			} else {
				$(".back-to-top").fadeOut(duration);
				$(".back-to-top-center").fadeOut(duration);
				if ($("#sv-rbadge-box").length) {
					$("#sv-rbadge-box").fadeOut(duration);
				}
			}
		}
	});

	window.addEventListener("resize", function() {
		isDesktop = window.matchMedia("(min-width: 768px)").matches;
	});
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.plugins.external.svbadge: ondocumentready"); // eslint-disable-line no-console
});
